module.exports = "/_next/static/images/HeroMobile@2x-27a7774ab3b71d7c3faf68eb7ffa11ab.png";